import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";
import { useStore } from "vuex";
import NextButton from "@/components/shared/NextButton.vue";
import type { Stipulation } from "@/models/opal";
import SelfCertificationDetailsFormModal from "@/components/modals/SelfCertificationDetailsFormModal.vue";
import { StipulationStatusIds } from "@/config/constants";

interface Props {
  stip: Stipulation;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SelfCertificationDetailsInput',
  props: {
    stip: {}
  },
  emits: ["success"],
  setup(__props: any, { emit: __emit }) {

const store = useStore();

const props = __props;

const emit = __emit;

const modalActive = computed<boolean>(() => store.state.modal.selfCertificationDetailsModalActive);

const completed = computed<boolean>(
  () =>
    props.stip.stipulationStatusId === StipulationStatusIds.COMPLETED ||
    props.stip.stipulationStatusId === StipulationStatusIds.CU_OVERRIDE,
);

function openModal() {
  store.dispatch("modal/openSelfCertificationDetailsModal");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!completed.value)
      ? (_openBlock(), _createBlock(NextButton, {
          key: 0,
          onClick: openModal,
          text: "Add Self-Certification Details"
        }))
      : _createCommentVNode("", true),
    (modalActive.value)
      ? (_openBlock(), _createBlock(SelfCertificationDetailsFormModal, {
          key: 1,
          stip: __props.stip,
          onSuccess: _cache[0] || (_cache[0] = ($event: any) => (emit('success', $event)))
        }, null, 8, ["stip"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})